import t from './actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'

const signupActions = {
	showSignupReferralInput() {
		return {
			type: t.SIGNUP_SHOW_REFERRAL_INPUT,
		}
	},
	sendEmailSignupForm(values, resolve, reject) {
		return {
			type: t.SIGNUP_SEND_EMAIL_FORM,
			values,
			resolve,
			reject,
		}
	},
	sendSsoSignupForm(values, resolve, reject) {
		return {
			type: t.SIGNUP_SEND_SSO_FORM,
			values,
			resolve,
			reject,
		}
	},
	getSignupPasswordConditions(recoveryKey) {
		return {
			type: t.SIGNUP_GET_PASSWORD_CONDITIONS,
			recoveryKey,
		}
	},
	obLessonDownloadSuccess() {
		return {
			type: t.SIGNUP_OB_LESSON_DOWNLOAD_SUCCESS,
		}
	},
	obLessonDownloadError() {
		return {
			type: t.SIGNUP_OB_LESSON_DOWNLOAD_ERROR,
		}
	},
	navigateToTerms() {
		return {
			type: t.SIGNUP_NAVIGATE_TO_TERMS,
		}
	},
	navigateToStudent() {
		return {
			type: t.SIGNUP_NAVIGATE_TO_STUDENT,
		}
	},
	navigateToGmail() {
		return {
			type: t.SIGNUP_NAVIGATE_TO_GMAIL,
		}
	},
	navigateToOffice() {
		return {
			type: t.SIGNUP_NAVIGATE_TO_OFFICE,
		}
	},
	navigateToEmail() {
		return {
			type: t.SIGNUP_NAVIGATE_TO_EMAIL,
		}
	},

	confirmStudent() {
		return {
			type: t.OPEN_CONFIRM,
			confirmType: confirmTypes.SIGNUP_STUDENT_VALIDATION,
		}
	},
	studentConfirmed() {
		return {
			type: t.SIGNUP_STUDENT_CONFIRMED,
		}
	},
	teacherConfirmed() {
		return {
			type: t.SIGNUP_TEACHER_CONFIRMED,
		}
	},
	signUpInitialize(locationSearch, params) {
		return {
			type: t.SIGNUP_INITIALIZE,
			locationSearch,
			params,
		}
	},
	teacherEmailAlreadyRegistered(email) {
		return {
			type: t.SIGNUP_TEACHER_EMAIL_ALREADY_REGISTERED,
			email,
		}
	},
}

export default signupActions
